import * as React from 'react';
import { Link, browserHistory } from 'react-router';
import * as c from 'models/constants';
import { IUserLanguage } from 'models/user/userlanguage';
import { translate } from 'react-i18next';
import { changeLanguage } from 'redux/modules/user/userlanguage';
import { ILanguage } from 'models/common';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IUserPreferences } from 'models/user/userpreferences';
import { getPublishedMenuItems } from 'redux/modules/menus/mainmenu';
import { IMainMenuAction } from 'models/mainmenu/mainmenu';
import { MenuItemType } from 'models/enums/menuitemtype';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import moment = require('moment');
import renderIcon from 'helpers/renderIcon';
const classNames = require('classnames');

interface IProps {
	t?: (key: string) => string;
	languageDomainValues?: ILanguage[];
	router?: any;
	context: any;
	userLanguage?: IUserLanguage;
	changeLanguage?: Redux.ActionCreator<IUserLanguage>;
	userPreferences?: IUserPreferences;
	preFooter?: boolean;
	restrictedMode?: boolean;
	darkFooter?: boolean;
	noFooter?: boolean;
	/* func props */
	getPublishedMenuItems?: (menuItemType: MenuItemType) => IMainMenuAction;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		changeLanguage: (language: number, updateUserPreferences: boolean) =>
			dispatch(changeLanguage(language, updateUserPreferences)),
		getPublishedMenuItems: (menuItemType: MenuItemType) => dispatch(getPublishedMenuItems(menuItemType)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalFooterComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onLanguageChange = this.onLanguageChange.bind(this);
	}

	public static defaultProps: Partial<IProps> = {
		preFooter: true,
	};

	public onLanguageChange(val: any) {
		const languageKey = parseInt(val, 10);
		this.redirectHome(null, languageKey);
		this.props.changeLanguage(languageKey, this.props.context.isAuthenticated());
		this.props.getPublishedMenuItems(MenuItemType.Portal);
	}

	public redirectHome(_, languageKey: number) {
		const culture = languageKey
			? this.props.languageDomainValues?.find((x) => x.key === languageKey)?.culture
			: this.props.userLanguage?.culture;

		if (culture) {
			browserHistory.push('/home/' + culture?.substring(0, 2));
		}
	}

	public scrollToTop() {
		window.scroll({
			behavior: 'smooth',
			top: 0,
		});
	}

	public render() {
		const { t, languageDomainValues, userLanguage, darkFooter, noFooter } = this.props;

		if (noFooter) {
			return null;
		}

		const culture = languageDomainValues?.find((x) => x.key === userLanguage.languageKey)?.culture;
		const currentPrivacyPolicyLanguages: string[] = ['en', 'sl'];
		const translationExists: boolean = currentPrivacyPolicyLanguages.some(
			(lang) => culture?.substring(0, 2).includes(lang),
		);
		const productLinksTitle: JSX.Element = <h4>{t('App_Name')}</h4>;
		const productLinks: JSX.Element[] = [
			!this.props?.restrictedMode && <Link to="/salons">{t('Portal_Footer_Salons')}</Link>,
			culture?.substring(0, 2) === 'sl' ? <Link to="/magazine/page/svet-lepote">Svet lepote</Link> : null, // Only show on Slovenian language, link will work only on production
		].filter((a) => a);

		const businessLinksTitle: JSX.Element = <h4>{t('Portal_Footer_Business')}</h4>;
		const businessLinks: JSX.Element[] = [
			/* <Link to={'/about/' + culture?.substring(0, 2)} key={`businessLinks-1`}>{t('Portal_Footer_About')}</Link>, */
			// <a rel="noopener" target='_blank' href='https://glossiq.io/' key={`businessLinks-2`}>{t('Portal_Footer_AboutUs')}</a>,
			<Link to="/forBusiness" key={`businessLinks-3`}>
				{t('Portal_Footer_OpenSalon')}
			</Link>,
			// TASK-8016_Redirect_to_the_English_version_of_Privacy_Policy_and_Terms_of_Use
			<Link to={'/termsofuse/' + culture?.substring(0, 2)} key={`businessLinks-4`}>
				{t('Portal_Footer_TermsAndConditions')}
			</Link>, // Uncomment when we have terms and conditions in all languages
			// <Link to={'/privacypolicy/' + culture?.substring(0, 2)} key={`businessLinks-5`}>{t('Portal_Footer_PrivacyPolicy')}</Link>    // Uncomment when we have privacy policy in all languages
			//<Link to={'/termsofuse/en'} key={`businessLinks-6`}>{t('Portal_Footer_TermsAndConditions')}</Link>,                             // Remove when we have terms and conditions in all languages
			translationExists ? (
				<Link to={'/privacypolicy/' + culture?.substring(0, 2)} key={`businessLinks-7`}>
					{t('Portal_Footer_PrivacyPolicy')}
				</Link>
			) : (
				<Link to={'/privacypolicy/en'} key={`businessLinks-7`}>
					{t('Portal_Footer_PrivacyPolicy')}
				</Link>
			), // Remove when we have privacy policy in all languages
			<Link to="/cookiepolicy/en" key={`businessLinks-8`}>
				{t('Portal_Footer_CookiePolicy')}
			</Link>,
		];

		const contactLinksTitle: JSX.Element = <h4>{t('Portal_Footer_ContactUs')}</h4>;
		const contactLinks: JSX.Element[] = [
			<a href="mailto:support@glossiq.com" key={`contactLink-1`}>
				{t('Portal_Footer_CustomerSupport')}
			</a>,
			<a href="mailto:info@glossiq.com" key={`contactLink-2`}>
				{t('Portal_Footer_Partnership')}
			</a>,
		];

		const followLinksTitle: JSX.Element = <h4>{t('Portal_Footer_Follow')}</h4>;
		const followLinks: JSX.Element[] = [
			<a
				rel="noopener noreferrer"
				href="https://www.instagram.com/glossiq_global/"
				target="_blank"
				className="socialIcons__instagram"
				key={`followLink-1`}
			>
				{renderIcon('instagramFooter')}
			</a>,
			<a
				rel="noopener noreferrer"
				href="https://www.facebook.com/Glossiq-102944031650925/"
				target="_blank"
				className="socialIcons__facebook"
				key={`followLink-2`}
			>
				{renderIcon('facebookFooter')}
			</a>,
			<a
				rel="noopener noreferrer"
				href="https://www.linkedin.com/company/glossiq/"
				target="_blank"
				className="socialIcons__linkedin"
				key={`followLink-3`}
			>
				{renderIcon('linkedinFooter')}
			</a>,
			<a
				rel="noopener noreferrer"
				href="https://www.tiktok.com/@glossiq_slovenia"
				target="_blank"
				className="socialIcons__tiktok"
				key={`followLink-4`}
			>
				{renderIcon('tiktokFooter')}
			</a>,
			<a
				rel="noopener noreferrer"
				href="https://www.youtube.com/@GlossiqSocial"
				target="_blank"
				className="socialIcons__youtube"
				key={`followLink-5`}
			>
				{renderIcon('youtubeFooter')}
			</a>,
		];

		const copyrightsText = 'Copyright 2021–' + moment().format('YYYY') + ' Glossiq, d.o.o.';

		return (
			<footer
				className={classNames('mainFooter', {
					'restricted-mode': this.props?.restrictedMode,
					mainFooterDark: darkFooter,
				})}
			>
				<div className="container footerDesktopMenu">
					<div className="row">
						<div className="col-lg-3 col-xl-3">
							<div className="footerDesktopMenu__logo">
								{!this.props?.restrictedMode && <Link to="/">{renderIcon('logoFooter')}</Link>}
								{this.props?.restrictedMode && renderIcon('logoFooter')}
							</div>
							<div className="d-xl-none footerDesktopMenu__socialIcons_lg">
								{followLinksTitle}
								<ul className="footerDesktopMenu__socialIcons">
									{followLinks.map((fl, i) => {
										return <li key={i}>{fl}</li>;
									})}
								</ul>
							</div>
						</div>
						<div className="col-lg-3 col-xl-2">
							{productLinksTitle}
							<ul className="footerDesktopMenu__productLinks">
								{productLinks.map((pl, i) => {
									return <li key={i}>{pl}</li>;
								})}
							</ul>
						</div>
						<div className="col-lg-3 col-xl-2">
							{businessLinksTitle}
							<ul className="footerDesktopMenu__businessLinks">
								{businessLinks.map((bl, i) => {
									return <li key={i}>{bl}</li>;
								})}
							</ul>
						</div>
						<div className="col-lg-3 col-xl-2">
							{contactLinksTitle}
							<ul className="footerDesktopMenu__contactLinks">
								{contactLinks.map((cl, i) => {
									return <li key={i}>{cl}</li>;
								})}
							</ul>
						</div>
						<div className="d-lg-none d-xl-block col-xl-3">
							{followLinksTitle}
							<ul className="footerDesktopMenu__socialIcons">
								{followLinks.map((sl, i) => {
									return <li key={i}>{sl}</li>;
								})}
							</ul>
						</div>
					</div>
				</div>

				<div className="container footerBottomCopyrightDesktop">
					<div className="row">
						<div className="col-12">
							<div className="footerBottomCopyright-wrapper">
								<p className="p12">{copyrightsText}</p>
							</div>
						</div>
					</div>
				</div>

				<div className="container-fluid footerMobileMenu">
					<div className="row">
						<div className="col-12">
							<div className="footerMobileMenu__logo">
								{!this.props?.restrictedMode && <Link to="/">{renderIcon('logoFooter')}</Link>}
								{this.props?.restrictedMode && renderIcon('logoFooter')}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">{productLinksTitle}</div>
						{productLinks.map((pl, i) => {
							return (
								<div className="col-6" key={i}>
									<div className="footerMobileMenu__link">{pl}</div>
								</div>
							);
						})}
					</div>
					<div className="row">
						<div className="col-12">{businessLinksTitle}</div>
						{businessLinks.map((bl, i) => {
							return (
								<div className="col-6" key={i}>
									<div className="footerMobileMenu__link">{bl}</div>
								</div>
							);
						})}
					</div>
					<div className="row">
						<div className="col-12">{contactLinksTitle}</div>
						{contactLinks.map((cl, i) => {
							return (
								<div className="col-6" key={i}>
									<div className="footerMobileMenu__link">{cl}</div>
								</div>
							);
						})}
					</div>
					<div className="row">
						<div className="col-12">{followLinksTitle}</div>
						<div className="col-12">
							<div className="footerMobileMenu__socialIcons">
								{followLinks.map((sl, i) => {
									return (
										<div className="footerMobileMenu__link" key={i}>
											{sl}
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>

				<div className="container-fluid footerBottomCopyrightMobile">
					<div className="row">
						<div className="col-12 px-0">
							<div className="footerBottomCopyrightMobile__line"></div>
						</div>
						<div className="col-12">
							<div className="footerBottomCopyright-wrapper">
								<p className="p12">{copyrightsText}</p>
							</div>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

const PortalFooter = withAuthContext(PortalFooterComponent);
export { PortalFooter };
